var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-bills-list section-full"},[_c('h2',{directives:[{name:"translate",rawName:"v-translate"}],staticClass:"ttl2 popup-header"},[_vm._v("Reprint bill")]),_c('bills-table',{attrs:{"bills":_vm.bills},on:{"billClicked":_vm.showBillModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }